// oxlint-disable max-lines
import { graphql } from '../../../../gql';

export const CREATE_OR_UPDATE_UMSATZZIEL = graphql(`
  mutation CreateOrUpdateUmsaatzziel(
    $createOrUpdateUmsatzzielInput: CreateOrUpdateUmsatzziel!
  ) {
    createOrUpdateZiel: createOrUpdateUmsatzZiel(
      createOrUpdateUmsatzzielInput: $createOrUpdateUmsatzzielInput
    ) {
      __typename
      ... on Umsatz {
        __typename
        produktivitaet {
          amount
          currency
        }
        stunden
        wert {
          amount
          currency
        }
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
  }
`);

export const CREATE_OR_UPDATE_ABSATZZIEL = graphql(`
  mutation CreateOrUpdateAbsatzziel(
    $createOrUpdateAbsatzzielInput: CreateOrUpdateAbsatzziel!
  ) {
    createOrUpdateZiel: createOrUpdateAbsatzziel(
      createOrUpdateAbsatzzielInput: $createOrUpdateAbsatzzielInput
    ) {
      ... on controlling_Absatz {
        __typename
        produktivitaet {
          mpt
          stueck
        }
        stunden
        wert
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
  }
`);

export const CREATE_OR_UPDATE_ABSATZ_UMSATZ_ZIEL = graphql(`
  mutation CreateOrUpdateAbsatzUmsatzZiel(
    $createOrUpdateAbsatzZielInput: CreateOrUpdateAbsatzziel!
    $createOrUpdateUmsatzZielInput: CreateOrUpdateUmsatzziel!
  ) {
    createOrUpdateAbsatzZiel: createOrUpdateAbsatzziel(
      createOrUpdateAbsatzzielInput: $createOrUpdateAbsatzZielInput
    ) {
      ... on controlling_Absatz {
        __typename
        produktivitaet {
          mpt
          stueck
        }
        stunden
        wert
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
    createOrUpdateUmsatzZiel: createOrUpdateUmsatzZiel(
      createOrUpdateUmsatzzielInput: $createOrUpdateUmsatzZielInput
    ) {
      __typename
      ... on Umsatz {
        __typename
        produktivitaet {
          amount
          currency
        }
        stunden
        wert {
          amount
          currency
        }
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
  }
`);

export const CREATE_OR_UPDATE_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ = graphql(`
  mutation CreateOrUpdateUmsatzPlanWertAndInterneNotiz(
    $createOrUpdateUmsatzPlanInput: CreateOrUpdateUmsatzPlan!
    $createOrUpdateInterneNotizInput: CreateOrUpdateInterneNotiz!
  ) {
    createOrUpdateInterneNotiz(
      createOrUpdateInterneNotizInput: $createOrUpdateInterneNotizInput
    ) {
      ... on InterneNotiz {
        datum
        interneNotiz
      }
    }
    createOrUpdateUmsatzPlan(
      createOrUpdateUmsatzPlanInput: $createOrUpdateUmsatzPlanInput
    ) {
      __typename
      ... on Umsatz {
        __typename
        produktivitaet {
          amount
          currency
        }
        stunden
        wert {
          amount
          currency
        }
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on UmsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
  }
`);

export const CREATE_OR_UPDATE_ABSATZ_PLANWERT_AND_INTERNE_NOTIZ = graphql(`
  mutation CreateOrUpdateAbsatzPlanWertAndInterneNotiz(
    $createOrUpdateAbsatzPlanInput: CreateOrUpdateAbsatzPlan!
    $createOrUpdateInterneNotizInput: CreateOrUpdateInterneNotiz!
  ) {
    createOrUpdateInterneNotiz(
      createOrUpdateInterneNotizInput: $createOrUpdateInterneNotizInput
    ) {
      ... on InterneNotiz {
        datum
        interneNotiz
      }
    }
    createOrUpdateAbsatzPlan(
      createOrUpdateAbsatzPlanInput: $createOrUpdateAbsatzPlanInput
    ) {
      __typename
      ... on controlling_Absatz {
        __typename
        produktivitaet {
          mpt
          stueck
        }
        stunden
        wert
      }
      ... on UmsatzplanungUnkownError {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultStandortNotFound {
        __typename
        message
        type
      }
      ... on AbsatzUpdateResultUpdateError {
        __typename
        message
        type
      }
    }
  }
`);

export const CREATE_OR_UPDATE_ABSATZ_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ =
  graphql(`
    mutation CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotiz(
      $createOrUpdateAbsatzPlanInput: CreateOrUpdateAbsatzPlan!
      $createOrUpdateUmsatzPlanInput: CreateOrUpdateUmsatzPlan!
      $createOrUpdateInterneNotizInput: CreateOrUpdateInterneNotiz!
    ) {
      createOrUpdateInterneNotiz(
        createOrUpdateInterneNotizInput: $createOrUpdateInterneNotizInput
      ) {
        ... on InterneNotiz {
          datum
          interneNotiz
        }
      }
      createOrUpdateAbsatzPlan(
        createOrUpdateAbsatzPlanInput: $createOrUpdateAbsatzPlanInput
      ) {
        __typename
        ... on controlling_Absatz {
          __typename
          produktivitaet {
            mpt
            stueck
          }
          stunden
          wert
        }
        ... on UmsatzplanungUnkownError {
          __typename
          message
          type
        }
        ... on AbsatzUpdateResultStandortNotFound {
          __typename
          message
          type
        }
        ... on AbsatzUpdateResultUpdateError {
          __typename
          message
          type
        }
      }
      createOrUpdateUmsatzPlan(
        createOrUpdateUmsatzPlanInput: $createOrUpdateUmsatzPlanInput
      ) {
        __typename
        ... on Umsatz {
          __typename
          produktivitaet {
            amount
            currency
          }
          stunden
          wert {
            amount
            currency
          }
        }
        ... on UmsatzplanungUnkownError {
          __typename
          message
          type
        }
        ... on UmsatzUpdateResultStandortNotFound {
          __typename
          message
          type
        }
        ... on UmsatzUpdateResultUpdateError {
          __typename
          message
          type
        }
      }
    }
  `);

export const UPDATE_TAGEBUCH_EINSTELLUNGEN = graphql(`
  mutation UpdateTagebuchEinstellungen(
    $tagebuchEinstellungenUpdateInput: TagebuchEinstellungenUpdateInput!
  ) {
    updateTagebuchEinstellungen(
      updateTagebuchEinstellungenInput: $tagebuchEinstellungenUpdateInput
    ) {
      ... on TagebuchEinstellungen {
        __typename
        absatzProduktivitaet {
          absatzVorgabe
          zielProduktivitaet
        }
        umsatzProduktivitaet {
          zielProduktivitaet
        }
      }
      ... on TagebuchEinstellungenUpdateError {
        message
        type
        __typename
      }
    }
  }
`);

export const CREATE_OR_UPDATE_INTERNE_NOTIZ = graphql(`
  mutation CreateOrUpdateInterneNoitz(
    $createOrUpdateInterneNotizInput: CreateOrUpdateInterneNotiz!
  ) {
    createOrUpdateInterneNotiz(
      createOrUpdateInterneNotizInput: $createOrUpdateInterneNotizInput
    ) {
      ... on InterneNotiz {
        datum
        interneNotiz
      }
      ... on TagesInformationenInterneNotizUpdateError {
        message
      }
      ... on UmsatzplanungUnkownError {
        message
      }
    }
  }
`);
